module.exports = __webpack_public_path__ + "54cf98f5/img/pwrd-by-sourcery-black.bba9ba41.svg";